module.exports = __webpack_public_path__ + "img/fire.41e4b54e.png";